import mobileTest from "is-mobile";
import "../css/cms.scss";


const isMobile = mobileTest();
if (isMobile === false) {
    import(
        /* webpackChunkName: "btntotop" */
        "./components/btntotop.js"
    ).then((btntotopImport) => {
        btntotopImport.btntotop();
    });
}
